import { css } from 'styled-components';
import { focusStyles } from './focus';

export const inputStyles = css`
  display: ${({ inline }) => (inline ? 'inline-block' : 'block')};
  background-size: 15px 15px;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  padding: 10px 8px 9px;
  outline: 0;
  border: 2px solid ${({ theme }) => theme.palette.borderDark};

  &:focus {
    ${focusStyles}
  }
`;
